import { ObjectValues } from 'types';

export const SORTING_ORDER = {
  A_TO_Z: 'a_to_z',
  Z_TO_A: 'z_to_a',
} as const;

export type SortingOrder = ObjectValues<typeof SORTING_ORDER>;

export type SortingField = {
  name: string;
  order: SortingOrder;
};

export type SortByForm = {
  sortBy: SortingField[];
};

export type SortingDirectionValues = Record<
  string,
  Record<SortingOrder, string>
>;
